<div class="row" *ngIf="showHeader">
  <div class="col-sm-1"></div>
  <div class="col-sm-10">
    <h1 style="font-family: Roboto, Helvetica Neue, sans-serif; font-size: 40px; font-weight: bold; color: black; margin-left: -15px;">Reporting Services</h1>
  </div>
  <div class="col-sm-1"></div>
</div>
<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-3 mainLabel">Reports</div>
  <div class="col-sm-3 mainLabel">Layout</div>
  <div class="col-sm-3 mainLabel">Actions</div>
  <div class="col-sm-1 mainLabel"></div>
  <div class="col-sm-1"></div>
</div>
<div class="row">
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select [(ngModel)]="currentSelectedReport"
                  id="currentSelectedReport"
                  name="currentSelectedReport"
                  class="modifiedDropDown"
                  (selectionChange)="selectReport()">
        <mat-option *ngFor="let report of userState?.reportExportState?.reportStandardTypes" [value]="report">{{ report.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select id="currentSelectedLayout"
                  class="currentSelectedLayout"
                  [(ngModel)]="currentSelectedLayout"
                  (selectionChange)="selectLayout()">
        <mat-option *ngFor="let layout of currentSelectedReport?.layouts" [value]="layout">{{ layout.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select id="currentSelectedAction" [(ngModel)]="currentSelectedAction">
        <mat-option value="Generate">Generate Report</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1">
    <button mat-raised-button class="piButton" style="margin-top: 10px; margin-left: 8px" (click)="goClick()">GO</button>
  </div>
</div>
